export default {
  getUniqueId: () => 'web-unique-id',
  getDeviceId: () => 'web-device',
  getVersion: () => '1.0.0',
  getBuildNumber: () => '1',
  getBundleId: () => 'com.bluehms.app',
  getSystemName: () => 'Web',
  getSystemVersion: () => '1.0',
  getModel: () => 'Browser',
  getBrand: () => 'Generic',
  isTablet: () => false,
};
